export default {}

export const baseUrl = 'http://www.jbtsc.cn:8013/prod-api'
// export const baseUrl = 'http://localhost:8013/prod-api'



// WEBPACK FOOTER //
// ./src/api/api.js